import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Print.svg",
  "use": "Print.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Print.svg\"><path d=\"M55.0208,52.0208h-46a1,1,0,0,1-1-1v-16a5,5,0,0,1,5-5h38a5,5,0,0,1,5,5v16A1,1,0,0,1,55.0208,52.0208Zm-4.1592-5.5547-4.0021-6a1,1,0,0,0-.8322-.4452H18.0128a1,1,0,0,0-.8324.4452l-4.002,6a1,1,0,0,0,.8324,1.5547H50.0292a1,1,0,0,0,.8324-1.5547ZM46.0208,28.0208h-28a1,1,0,0,1-1-1v-16a3,3,0,0,1,3-3h24a3,3,0,0,1,3,3v16A1,1,0,0,1,46.0208,28.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol